import React from "react";
import { useHistory } from "react-router-dom";
import Breadcrumb from "../generic/Breadcrumb";

interface PanelCardPropsTypes {
  className?: string;
  height?: string;
  tittle?: string;
  specificity?: string;
  showViewAll?: boolean;
  onViewAll?: () => void;
  viewAllLabel?: string;
  path?: string;
  showBreadcrumb?: boolean; 
  children: React.ReactNode;
}

const PanelCard = ({
  className,
  height,
  children,
  tittle,
  specificity,
  showViewAll,
  onViewAll,
  viewAllLabel,
  path,
  showBreadcrumb,
}: PanelCardPropsTypes) => {
  const history = useHistory();

  const handleClick = () => {
    if (path) {
      history.push(path);
    }
  };

  return (
    <div
      className={`bg-pcg-borderStrong rounded-[10px] px-4 py-3 flex min-h-0 flex-1 flex-col gap-4 ${
        path ? "cursor-pointer hover:opacity-90 transition" : ""
      } ${className ?? ""}`}
      style={{ minHeight: height}}
      onClick={handleClick}
    >
      {showBreadcrumb && <Breadcrumb />}

      {(tittle || specificity || showViewAll) && (
        <div className="flex justify-between items-center">
          {tittle && (
            <h3 className="font-inter text-white font-sfpro-semibold">
              {tittle}
            </h3>
          )}

          {specificity && (
            <h3 className="font-inter text-white font-sfpro-semibold">
              {specificity}
            </h3>
          )}

          {showViewAll && (
            <button
              onClick={(e) => {
                e.stopPropagation();
                onViewAll?.();
              }}
              className="font-inter text-white font-sfpro-semibold hover:opacity-80 transition"
            >
              {viewAllLabel}
            </button>
          )}
        </div>
      )}

      {children}
    </div>
  );
};

export default PanelCard;
